module.exports = __webpack_public_path__ + "img/story-03.9453341a.png";